"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkspaceUsers = void 0;
var tslib_1 = require("tslib");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
/**
 * Hook allowing to download workspace users
 * @param config - configuration of the hook
 * @internal
 */
function useWorkspaceUsers(_a) {
    var search = _a.search, backend = _a.backend, workspace = _a.workspace, onCancel = _a.onCancel, onError = _a.onError, onLoading = _a.onLoading, onPending = _a.onPending, onSuccess = _a.onSuccess;
    var effectiveBackend = sdk_ui_1.useBackend(backend);
    var effectiveWorkspace = sdk_ui_1.useWorkspace(workspace);
    ts_invariant_1.default(effectiveBackend, "The effectiveBackend in useWorkspaceUsers must be defined. Either pass it as a config prop or make sure there is a BackendProvider up the component tree.");
    ts_invariant_1.default(effectiveWorkspace, "The effectiveWorkspace in useWorkspaceUsers must be defined. Either pass it as a config prop or make sure there is a WorkspaceProvider up the component tree.");
    var promise = function () {
        var loader = effectiveBackend.workspace(effectiveWorkspace).users();
        if (search) {
            loader = loader.withOptions({ search: "%" + search });
        }
        return loader.queryAll();
    };
    return sdk_ui_1.useCancelablePromise({ promise: promise, onCancel: onCancel, onError: onError, onLoading: onLoading, onPending: onPending, onSuccess: onSuccess }, [
        effectiveBackend,
        effectiveWorkspace,
        search,
    ]);
}
exports.useWorkspaceUsers = useWorkspaceUsers;
//# sourceMappingURL=useWorkspaceUsers.js.map